import styled from 'styled-components';

const StyledMultipleCloudChartWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export { StyledMultipleCloudChartWrapper };
